import { firestore as db } from "./firebase";
import { BaseModel } from "./models";
import { getStatuses, StatementListItem } from "./statements";

export const COLLECTION_STATEMENTS_COMMENTEDON: string =
  "statements_commentedon";

export type StatementCommentedOn = BaseModel & {
  userId: string;
  commentId: string;
  statement: {
    statementId: string;
    title: string;
    status: string;
    slug: string;
  };
};

export async function getStatementsUserHasCommentedOn(
  userId: string,
  isAdmin: boolean
) {
  const data = await db
    .collection(COLLECTION_STATEMENTS_COMMENTEDON)
    .where("userId", "==", userId)
    .where("statement.status", "in", getStatuses(isAdmin))
    .get();

  let statements: StatementCommentedOn[] = [];
  data.forEach((doc) => statements.push({ ...doc.data() } as any));
  return statements;
}

export function mapToListItem(
  statement: StatementCommentedOn
): StatementListItem {
  return {
    id: statement.statement.statementId,
    slug: statement.statement.slug,
    title: statement.statement.title,
  };
}
